<!-- 公共组件--查看短信内容 -->

<template>
  <myPopup :flag="isShow" @close="close">
    <div>
      <div class="phone_box">
        <div class="phone_inner" v-if="moduleType == 1">
          <div class="phone_left">
            <img src="@/assets/images/dongdong/touxiang.png" alt="">
          </div>
          <div class="phone_right">
            <span>客服</span>
            <!-- 商品推荐 -->
            <div class="phone_content" v-if="myData.messageType == 1">
              <div class="phone_title">{{ myData.massTheme }}</div>
              <div class="phone_invite">{{ myData.invitationText }}</div>
              <!-- 列表模式 -->
              <div class="phone_list" v-for="item, index in myData.skus" :key="index">
                <div class="list_item" v-if="myData.showType == 2 && index < 4">
                  <div><img :src="item.image"></div>
                  <div class="goods_info">
                    <div>{{ item.skuName }}</div>
                    <div>￥{{ item.price }}</div>
                  </div>
                </div>
              </div>
              <!-- 大图模式 -->
              <div class="phone_imgList" v-if="myData.showType == 1">
                <div class="goods_imgBox" v-for="item, index in myData.skus" :key="index" v-if="index < 6">
                  <img :src="item.image">
                  <div>￥{{ item.price }}</div>
                </div>
              </div>
              <div class="showMore" v-if="myData.isShowBtn == 1">查看更多</div>
            </div>
            <!-- 图文消息 -->
            <div class="phone_content" v-if="myData.messageType == 2">
              <!-- 上图下文 -->
              <div v-if="myData.picStyle == 1">
                <img style="width: 164px;height: 80px;border-radius: 8px;" :src="myData.picUrl" v-if="myData.picUrl">
                <div style="width: 164px;height: 80px;border-radius: 8px;background: #f3f4f5;" v-else></div>
                <div class="phone_title" style="margin-top: 8px;">{{ myData.massTheme }}</div>
                <div class="phone_invite">{{ myData.textMessageContent }}</div>
              </div>
              <!-- 左图右文 -->
              <div v-if="myData.picStyle == 2">
                <div class="phone_title">{{ myData.massTheme }}</div>
                <div style="display: flex;align-items: center;margin-top: 8px;">
                  <img style="width: 50px;height: 50px;border-radius: 8px;margin-right: 4px;" :src="myData.picUrl"
                    v-if="myData.picUrl">
                  <div style="width: 180px;height: 50px;border-radius: 8px;margin-right: 4px;background: #f3f4f5;"
                    v-else>
                  </div>
                  <div style="font-size: 10px;color: #999999;line-height: 13px;">{{ myData.textMessageContent }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 文本消息 -->
            <div class="phone_content" v-if="myData.messageType == 3">
              {{ myData.textMessageContent }}
            </div>
          </div>
        </div>
        <div class="phone_inner" v-if="moduleType == 2">
          <div class="phone_left">
            <img src="@/assets/images/dongdong/touxiang.png" alt="">
          </div>
          <div class="phone_right">
            <div class="phone_content">
              <div class="phone_title">{{ myData.welcomeContent }}</div>
            </div>
          </div>
        </div>
        <div class="phone_inner" v-if="moduleType == 2" style="margin-top:0px;">
          <div class="phone_left">
            <img src="@/assets/images/dongdong/touxiang.png" alt="">
          </div>
          <div class="phone_right">
            <div class="phone_content">
              <div class="phone_title">{{ myData.massTheme }}</div>
              <div class="phone_invite">{{ myData.invitationText }}</div>
              <div class="openFW">开启服务</div>
              <!-- <div class="yqImg"></div> -->
              <!-- <div class="quanyi_icon">
                <div>
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div>
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div>
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
                <div>
                  <img src="@/assets/images/hot_mrq.png" alt="">
                  <span>图标名称</span>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </myPopup>
</template>

<script>
import myPopup from '@/components/myPopupForSms'

export default {
  components: {
    myPopup
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object
    },
    moduleType: { // 模板类型  1发送专享消息 2邀请专享用户
      type: Number | String,
      default: 1
    }
  },
  data() {
    return {
      myData: {},
    }
  },
  created() {
    this.myData = { ...this.formData }
    this.myData.skus = JSON.parse(this.myData.skus)
    console.log(this.myData);
  },
  mounted() {
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
  }
}
</script>

<style lang="scss" scoped>
.phone_box {
  position: relative;
  width: 255px;
  height: 503px;
  background-image: url("../assets/images/dongdong/phone.png");
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;

  .phone_inner {
    display: flex;
    margin-top: 74px;
    padding-left: 18px;

    .phone_left {
      img {
        height: 30px;
        height: 30px;
      }
    }

    .phone_right {
      padding-left: 4px;
      padding-top: 3px;
      color: #333333;

      >span {
        font-size: 12px;
      }

      .phone_content {
        width: 180px;
        border-radius: 8px;
        background: #FFFFFF;
        padding: 8px;
        margin-top: 4px;
        color: #333333;
        letter-spacing: 2px;
        line-height: 18px;

        .phone_title {
          font-weight: 400;
          font-size: 12px;
        }

        .phone_invite {
          margin-top: 4px;
          color: #999999;
          font-size: 10px;
          line-height: 14px;
        }

        .openFW {
          color: white;
          background: #fe4d45;
          width: 96px;
          height: 23px;
          line-height: 23px;
          border-radius: 10px;
          text-align: center;
          margin-left: 34px;
          font-size: 12px;
        }

        .list_item {
          display: flex;
          width: 100%;
          height: 46px;
          margin-top: 8px;

          img {
            width: 46px;
            height: 46px;
            border-radius: 4px;
          }

          .goods_info {
            margin-left: 8px;
            font-size: 10px;
            line-height: 14px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 1px 0;

            >div:nth-of-type(1) {
              -webkit-line-clamp: 2;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .phone_imgList {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
        }

        .goods_imgBox {
          width: 78px;
          height: 78px;
          border-radius: 4px;
          overflow: hidden;
          margin-top: 8px;
          position: relative;

          img {
            width: 100%;
          }

          >div {
            border-radius: 0px 4px 0px 4px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #FFFFFF;
            font-size: 10px;
            line-height: 16px;
            padding: 0 5px;
          }
        }

        .showMore {
          text-align: center;
          font-size: 10px;
          border-top: 1px solid #dadada;
          padding-top: 5px;
          margin-top: 8px;
        }

        .quanyi_icon {
          display: flex;
          justify-content: space-evenly;
          margin-top: 8px;

          >div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 8px;

            img {
              width: 24px;
              height: 24px;
              margin: auto;
            }
          }
        }
      }
    }
  }
}
</style>